import { render, staticRenderFns } from "./MetaClosingMeeting.vue?vue&type=template&id=458fe41d&scoped=true&"
import script from "./MetaClosingMeeting.vue?vue&type=script&lang=ts&"
export * from "./MetaClosingMeeting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458fe41d",
  null
  
)

export default component.exports